<template>
  <el-form ref="offsetFormRef" :label-width="formLabelWidth('huge')" :model="form">
    <el-form-item :label="$t('bike.name236')" prop="iotTemperatureShowDeviation">
      <el-input-number v-model="form.iotTemperatureShowDeviation" :precision="0" />
    </el-form-item>
    <el-form-item :label="$t('bike.name237')" prop="iotTemperatureShowWarnDefaultValue">
      <el-input-number v-model="form.iotTemperatureShowWarnDefaultValue" :precision="0" />
    </el-form-item>
    <el-form-item :label="$t('bike.name239')" prop="controllerTemperatureShowDeviation">
      <el-input-number v-model="form.controllerTemperatureShowDeviation" :precision="0" />
    </el-form-item>
    <el-form-item :label="$t('bike.name240')" prop="controllerTemperatureShowWarnDefaultValue">
      <el-input-number v-model="form.controllerTemperatureShowWarnDefaultValue" :precision="0" />
    </el-form-item>
    <el-form-item :label="$t('bike.name243')" prop="batteryTemperatureShowDeviation">
      <el-input-number v-model="form.batteryTemperatureShowDeviation" :precision="0" />
    </el-form-item>
    <el-form-item :label="$t('bike.name244')" prop="batteryTemperatureShowWarnDefaultValue">
      <el-input-number v-model="form.batteryTemperatureShowWarnDefaultValue" :precision="0" />
    </el-form-item>
    <el-form-item :label="$t('bike.name247')" prop="motorTemperatureShowDeviation">
      <el-input-number v-model="form.motorTemperatureShowDeviation" :precision="0" />
    </el-form-item>
    <el-form-item :label="$t('bike.name248')" prop="motorTemperatureShowWarnDefaultValue">
      <el-input-number v-model="form.motorTemperatureShowWarnDefaultValue" :precision="0" />
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  name: 'ModelOffsetForm',
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  computed: {
    form: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>
